import { render, staticRenderFns } from "./RidesViewTable.vue?vue&type=template&id=13112810&scoped=true&lang=pug&"
import script from "./RidesViewTable.vue?vue&type=script&lang=js&"
export * from "./RidesViewTable.vue?vue&type=script&lang=js&"
import style0 from "./RidesViewTable.vue?vue&type=style&index=0&id=13112810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13112810",
  null
  
)

export default component.exports